import { Box, Button, ColorOptions, convertHexToRGBA, IconNew, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/native'
import { useEffect, useRef, useState } from 'react'
import { ScrollView } from 'react-native'
import { SvgImage } from '../../comps/SvgImage'
import { useLazyApiData, useStores } from '../../data/store'
import { Colors, getBase64Image, logEvent, numberToLocalString, testProps } from '../../util/util'
import { ColorMatrixImage } from './ColorMatrixImage'
import { ProgressWithTimer } from './ProgressBar'
import { QrHeader } from './QrHeader'
import { StatusLoaderAnimation } from './StatusLoaderAnimation'
import { styles } from './style'

const defaultTimerCount = 150 // in seconds
const GenerateQR = () => {
  const [timer, setTimer] = useState(defaultTimerCount)
  const expiryTimeRef = useRef(new Date(Date.now() + defaultTimerCount * 1000))
  const navigation = useNavigation()
  // navigation?.setOptions({
  //   headerShown: false,
  // })
  const params: any = useRoute()?.params

  const { getQrCode, pollStatus, checkStatus, setCustomToast } = useStores((root) => ({
    getQrCode: root.user.getQrCode,
    pollStatus: root.transactions.pollStatus,
    checkStatus: root.transactions.checkStatus,
    setCustomToast: root.response?.setCustomToast,
  }))
  const { amount, imgUri, merchantName, vpa, transactionId } = params ?? {}
  const [fetchDynamicQrCode, fetchQrCodeHandler] = useLazyApiData(getQrCode)
  const [pollPaymentStatus, pollStatusHandler] = useLazyApiData(pollStatus)
  const [checkTxnStatus, statusHandler] = useLazyApiData(checkStatus)
  let statusData = statusHandler.data || pollStatusHandler.data
  //statusData = testData // for dev testing

  const [progressVisible, setProgress] = useState(true)
  // const [reqFinished, setReqFinished] = useState(false)
  const [txnId, setTxnId] = useState(transactionId)
  const [imgUrl, setImageUri] = useState(imgUri)
  let reqFinished = useRef(true)

  const resetToQr = () => {
    navigation.reset({
      index: 0,
      routes: [
        {
          name: 'staticQr' as never,
          params: {
            refundedTxnId: txnId,
            refundAmount: amount,
            path: 'staticQr',
            isReset: true,
          },
        },
      ],
    })
  }

  useEffect(() => {
    if (fetchQrCodeHandler.state === 'fulfilled') {
      if (fetchQrCodeHandler?.data && fetchQrCodeHandler?.data?.status) {
        reqFinished.current = true
        expiryTimeRef.current = new Date(Date.now() + defaultTimerCount * 1000)
        setTimer(defaultTimerCount)
        setProgress(true)
        setTxnId(fetchQrCodeHandler?.data?.id ?? '')
        console.log('request pool: txnId', fetchQrCodeHandler?.data?.id)
        setImageUri(getBase64Image(fetchQrCodeHandler?.data?.qr))
      } else {
        setCustomToast(Colors.ERROR, 'Failed to generate QR', 'BOTTOM', 'NEGATIVE')
      }
    } else if (fetchQrCodeHandler.state === 'rejected') {
      setCustomToast(Colors.ERROR, 'Failed to generate QR', 'BOTTOM', 'NEGATIVE')
      resetToQr()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchQrCodeHandler.state])

  useEffect(() => {
    if (pollStatusHandler.state === 'fulfilled' || statusHandler.state === 'fulfilled') {
      //statusData = testData // for dev testing
      // console.log('request pool: status', txnId, pollStatusHandler.data)
      if (pollStatusHandler.data?.status !== 'initiated') {
        // reset req pool call
        setProgress(false)
        reqFinished.current = false
        navigateToPaymentStatus(pollStatusHandler.data)
      }
    } else if (pollStatusHandler.state === 'rejected') {
      navigation?.navigate('staticQr' as never)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pollStatusHandler.state])

  useEffect(() => {
    if (timer === 0) {
      console.log('QR timeout. hide progress')
      setProgress(false)
    }
  }, [timer])

  useEffect(() => {
    if (progressVisible) {
      if (reqFinished.current) {
        reqFinished.current = false
        setTimeout(() => {
          reqFinished.current = true
          pollPaymentStatus(txnId)
        }, 4000)
      }
      //console.log('progressVisible', progressVisible)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [progressVisible, timer, txnId])

  const handleTimer = (count: number) => {
    setTimer(count)
  }

  const handleGenerateQr = () => {
    // console.log('re-generate dynamic QR', amount)
    logEvent('btn_press', 'regenerate_qr')
    fetchDynamicQrCode(amount)
  }

  const onDismiss = () => {
    navigation?.goBack()
    // navigateToPaymentStatus() // for dev testing
  }

  const navigateToPaymentStatus = (data: any) => {
    navigation?.navigate(
      'qrPaymentStatus' as never,
      { autoDismiss: true, amount: amount, data: data, type: statusData.status, txnId: txnId } as never,
    )
  }

  return (
    <Box bg="SECONDARY" flex={1} alignItems="center" justifyContent={'space-between'}>
      <ScrollView
        contentContainerStyle={{
          alignItems: 'center',
          justifyContent: 'space-around',
          flex: 1,
        }}
        style={{
          overflow: 'auto',
          width: '100%',
          backgroundColor: Colors.SECONDARY,
        }}>
        <QrHeader merchantName={merchantName} vpa={vpa} />

        <Spacer size={30} direction="vertical" />
        <Box height={1} width={'50%'} bg={convertHexToRGBA('#fff', 20) as ColorOptions} />

        <Box alignItems="center">
          <Spacer size={20} direction="vertical" />
          <Box>
            <Text fontFamily={'JioType-Black'} fontSize={40} color={'WHITE'}>
              {'₹' + numberToLocalString(amount)}
            </Text>
          </Box>
          <Spacer size={10} direction="vertical" />

          {timer === 0 ? (
            <Text fontSize={12} fontFamily={'JioType-Medium'} color={'#FFABB1' as ColorOptions}>
              QR Expired
            </Text>
          ) : (
            <ProgressWithTimer
              defaultTimerCount={defaultTimerCount}
              time={timer}
              expiryTime={expiryTimeRef.current}
              setTimeLeft={handleTimer}
              hide={!progressVisible}
            />
          )}
          <Spacer size={10} direction="vertical" />
          <ModBox {...styles.qrImgcontainer} show={imgUrl?.length > 0} position={'relative'}>
            <ModBox p={10} bg={'WHITE'} borderRadius={14}>
              <ColorMatrixImage imgUri={imgUri} imgStyles={styles.imageView} timer={timer} />
            </ModBox>
            <ModBox
              show={timer === 0}
              position={'absolute'}
              top={0}
              left={0}
              right={0}
              bottom={0}
              zIndex={9}
              borderRadius={14}
              bg={convertHexToRGBA(Colors.PRIMARY, 70) as ColorOptions}
            />
            <ModBox
              position={'absolute'}
              justifyContent="center"
              show={timer === 0}
              width="100%"
              maxWidth={160}
              zIndex={10}>
              {fetchQrCodeHandler.state === 'pending' ? (
                <StatusLoaderAnimation />
              ) : (
                <Button
                  isFull
                  isRound
                  height={45}
                  type={'primary'}
                  {...testProps('generate-qr-button')}
                  onPress={handleGenerateQr}>
                  <Text color={'WHITE'} fontFamily="JioType-Bold" fontSize={16}>
                    Regenerate QR
                  </Text>
                </Button>
              )}
            </ModBox>
          </ModBox>
        </Box>
        <Box alignItems="center">
          <Spacer size={10} direction="vertical" />
          <Box
            alignItems={'center'}
            testID="close-qr"
            onPress={onDismiss}
            underlayColor={'PRIMARY'}
            justifyContent="center"
            marginVertical={20}
            width={40}
            height={40}
            borderRadius={40}
            backgroundColor={convertHexToRGBA('#fff', 20) as ColorOptions}>
            <IconNew id="ICON_CLOSE" size={20} color="WHITE" />
          </Box>
          <Spacer size={10} direction="vertical" />
          <Box {...styles.bhim}>
            <SvgImage color={'#fff'} imageName={'BhimUpi'} />
          </Box>
        </Box>
      </ScrollView>
    </Box>
  )
}

export default GenerateQR
